export const changeCount = (data) => {
    return {
        type: 'CHANGE_LOAD',
        data
    }
}